module.exports = __webpack_public_path__ + "media/images/landing/products/database-eee637b83c6293b669621062a55ccb1b.png";